const STOPWORDS = new Set([
  "A",
  "AU",
  "AUX",
  "D",
  "DE",
  "DES",
  "DU",
  "EN",
  "ET",
  "L",
  "LA",
  "LE",
  "LES",
  "OU",
  "PAR",
  "POUR",
  "SUR",
  "UN",
  "UNE",
]);

/** Code projet tiré du nom : « Senacle interne » → SEN-INT, « Methafor » →
 * METHAFOR. Majuscules sans accent, mots vides ignorés. */
export function projectCode(name: string): string {
  const words = name
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toUpperCase()
    .split(/[^A-Z0-9]+/)
    .filter((w) => w && !STOPWORDS.has(w));
  if (words.length === 0) return "PROJET";
  const [first] = words;
  if (words.length === 1 && first) return first.slice(0, 8);
  return words
    .slice(0, 2)
    .map((w) => w.slice(0, 3))
    .join("-");
}

/** Variante n d'un code déjà pris : SEN-INT, SEN-INT-2, SEN-INT-3… */
export function projectCodeVariant(code: string, attempt: number): string {
  return attempt <= 1 ? code : `${code}-${attempt}`;
}
